import { render, staticRenderFns } from "./PbcTextPost.vue?vue&type=template&id=37cc94b5&scoped=true&"
import script from "./PbcTextPost.vue?vue&type=script&lang=js&"
export * from "./PbcTextPost.vue?vue&type=script&lang=js&"
import style0 from "./PbcTextPost.vue?vue&type=style&index=0&id=37cc94b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cc94b5",
  null
  
)

export default component.exports